import { useTranslation } from 'react-i18next';
import { PasswordRules } from '../constants';

type RulesId =
  | PasswordRules.validLength
  | PasswordRules.includeUppercase
  | PasswordRules.includeLowercase;

interface Rule {
  id: RulesId;
  name: string;
}

/**
 * Custom hook that returns an array of password rules.
 *
 * @returns Array of password rules, each represented by an object with an `id` and a `name`.
 */
export const usePasswordRules = () => {
  const { t } = useTranslation();

  const passwordRules: Rule[] = [
    {
      id: PasswordRules.validLength,
      name: t('auth.create_password.validation.rule1'),
    },
    {
      id: PasswordRules.includeUppercase,
      name: t('auth.create_password.validation.rule2'),
    },
    {
      id: PasswordRules.includeLowercase,
      name: t('auth.create_password.validation.rule3'),
    },
  ];

  return passwordRules;
};
